var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{ref:"img",staticClass:"identicon",class:{ 'is--lg': _vm.size > 50 },attrs:{"src":_vm.src || _vm.identicon,"size":_vm.size}})}
var staticRenderFns = []

export { render, staticRenderFns }